export default class ReactRoutes {
    public static readonly ROOT = '/';
    public static readonly WELCOME = '/welcome';
    public static readonly ALUMNI_WELCOME = '/alumni-welcome';
    public static readonly ALUMNI_CONTACT_HELP = '/alumni-help';
    public static readonly ALUMNI_CONTACT_SELECT = '/alumni-contact-select';
    public static readonly ALUMNI_FAQ = '/help';
}
